import styled from 'styled-components';

import { Checkbox } from '../styled';

export const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const StyledCheckbox = styled(Checkbox)`
  input,
  label {
    cursor: pointer;
  }
  &.checkbox {
    input {
      border: 1px solid var(--cp-border, #fff);
    }
  }
`;
export const InputBox = styled.div`
  position: relative;
  height: 100%;
  /* fill Content and never grow past it, otherwise the chevron lands outside the row */
  flex: 1;
  min-width: 0;
  /* chevron pinned to the END of the row, vertically centred */
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 6px;
    margin-top: -5px;
    width: 6.5px;
    height: 6.5px;
    border: 1.5px solid var(--cp-text-tertiary, #bebebe);
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
  }
  && input {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* room so the chosen classes/categories never slide under the chevron */
    padding-right: 28px;
    width: 100%;
  }
`;
